import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["children", "className", "transparent", "noWidth"];
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import HeaderControls from "./o2-header-controls";
import HeaderLink from "./o2-header-link";
import HeaderLinks from "./o2-header-links";
import HeaderLogo from "./o2-header-logo";
import HeaderNavigClose from "./o2-header-navig-close";
import HeaderNavigContent from "./o2-header-navig-content";
import HeaderNavigItem from "./o2-header-navig-item";
import HeaderNavigMobile from "./o2-header-navig-mobile";
import HeaderNavigSub from "./o2-header-navig-sub";
import HeaderNavig from "./o2-header-navig";
import HeaderTopLink from "./o2-header-top-link";
import HeaderTop from "./o2-header-top";
import HeaderWidth from "./o2-header-width";

var O2Header = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(O2Header, _PureComponent);

  function O2Header() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = O2Header.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        transparent = _this$props.transparent,
        noWidth = _this$props.noWidth,
        attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var classes = classNames(className, "o2-header", {
      "o2-header--transparent": transparent
    });

    if (noWidth) {
      return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
        className: classes
      }), children);
    }

    return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
      className: classes
    }), /*#__PURE__*/React.createElement("div", {
      className: "o2-header__width"
    }, children));
  };

  return O2Header;
}(PureComponent);

_defineProperty(O2Header, "Controls", HeaderControls);

_defineProperty(O2Header, "Link", HeaderLink);

_defineProperty(O2Header, "Links", HeaderLinks);

_defineProperty(O2Header, "Logo", HeaderLogo);

_defineProperty(O2Header, "NavigClose", HeaderNavigClose);

_defineProperty(O2Header, "NavigContent", HeaderNavigContent);

_defineProperty(O2Header, "NavigItem", HeaderNavigItem);

_defineProperty(O2Header, "NavigMobile", HeaderNavigMobile);

_defineProperty(O2Header, "NavigSub", HeaderNavigSub);

_defineProperty(O2Header, "Navig", HeaderNavig);

_defineProperty(O2Header, "TopLink", HeaderTopLink);

_defineProperty(O2Header, "Top", HeaderTop);

_defineProperty(O2Header, "Width", HeaderWidth);

O2Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  transparent: PropTypes.bool,
  noWidth: PropTypes.bool
};
export default O2Header;